import React from 'react';
import { FiChevronDown } from 'react-icons/fi';
import styles from '../DashboardOverviewNew.module.scss';

// Fixed layout: biggest app on left spanning full height, right side is always a 2×2 equal grid.
// Column ratio 3:2:2 gives the left tile ~43% width, each right tile ~28.5%.
function buildTreemapLayout(items) {
  const n = items.length;

  if (n === 0) return { containerStyle: {}, itemStyles: [] };

  if (n === 1) {
    return {
      containerStyle: { gridTemplateColumns: '1fr', gridTemplateRows: '1fr' },
      itemStyles: [{}],
    };
  }

  if (n === 2) {
    return {
      containerStyle: {
        gridTemplateColumns: '3fr 2fr',
        gridTemplateRows: '1fr',
      },
      itemStyles: [
        { gridColumn: 1, gridRow: 1 },
        { gridColumn: 2, gridRow: 1 },
      ],
    };
  }

  if (n === 3) {
    return {
      containerStyle: {
        gridTemplateColumns: '3fr 2fr',
        gridTemplateRows: '1fr 1fr',
      },
      itemStyles: [
        { gridColumn: 1, gridRow: '1 / 3' },
        { gridColumn: 2, gridRow: 1 },
        { gridColumn: 2, gridRow: 2 },
      ],
    };
  }

  // 4–5 items: biggest left (full height) + 2×2 equal grid on right
  return {
    containerStyle: {
      gridTemplateColumns: '3fr 2fr 2fr',
      gridTemplateRows: '1fr 1fr',
    },
    itemStyles: [
      { gridColumn: 1, gridRow: '1 / 3' },
      { gridColumn: 2, gridRow: 1 },
      { gridColumn: 3, gridRow: 1 },
      n === 4
        ? { gridColumn: '2 / 4', gridRow: 2 }
        : { gridColumn: 2, gridRow: 2 },
      ...(n >= 5 ? [{ gridColumn: 3, gridRow: 2 }] : []),
    ],
  };
}

export const TopApplications = ({ data, isLoading = false }) => {
  const items = data || [];
  const { containerStyle, itemStyles } = buildTreemapLayout(items);

  return (
    <div
      className={styles.wideCard}
      style={isLoading ? { opacity: 0.5, pointerEvents: 'none' } : undefined}
    >
      <div className={styles.cardHeader}>
        <span className={styles.cardTitle}>Top Applications</span>
        <button className={styles.dayDropdown}>
          Total Time <FiChevronDown size={12} />
        </button>
      </div>

      <div className={styles.appsGrid} style={containerStyle}>
        {!items.length && (
          <div
            style={{
              gridColumn: '1 / -1',
              padding: '24px 0',
              textAlign: 'center',
              color: 'var(--gray-400)',
              fontSize: 13,
            }}
          >
            No data available
          </div>
        )}
        {items.map((app, i) => (
          <div
            key={app.name}
            className={styles.appTile}
            style={{ backgroundColor: app.color, ...itemStyles[i] }}
          >
            <span className={styles.appName}>{app.name}</span>
            <span className={styles.appTime}>{app.time}</span>
            <span className={styles.appPct}>{app.pct}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};
